export const BRANDS = "Brands"
export const BUSINESS = "Business"
export const COMMUNITY_IMPACT = "Community Impact"
export const SUSTAINABILITY = "Sustainability"
export const PRESS_RELEASE = "Press Release"
export const AWARDS = "Awards"
export const MINDFUL_SNACKING = "Mindful Snacking"
export const SNACKING_MADE_RIGHT = "Snacking Made Right"
export const CLEAR_ALL = "Clear All"
export const UK = "UK"
export const CAREERS = "Careers"
export const CAREERS_AND_PEOPLE = "Careers and People"